export default __webpack_public_path__ + "img/2_12-7d003421.png";